export const AssetType = { 
  WIND_TURBINE: 4,
  SOLAR_PANEL: 1,
  DAM: 2,
  GEOTHERMAL: 5,
  SOLID_BIOMASS: 6,
  ENERGY_MIX: "energyMix",
  FACTORY: "customerAsset",
  CONSUMPTION: "consumption"
}


// WEBPACK FOOTER //
// ./src/enums/AssetType.js